export default __webpack_public_path__ + "static/47-d996c572d12bfbb83e21b12261c2c07d.png";